import { i18next } from '@yola/ws-sdk';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import controlIds from '../constants/control-ids';
import settingIds from '../constants/setting-ids';
import previewGifs from '../constants/preview-gifs';
import computeContentAlignmentFallback from '../helpers/compute-content-alignment-fallback';

const ALIGNMENTS = {
  top: {
    id: 'top',
    glyph: 'move-up',
    value: 'start',
  },
  center: {
    id: 'center',
    glyph: 'move-middle',
    value: 'center',
  },
  bottom: {
    id: 'bottom',
    glyph: 'move-down',
    value: 'end',
  },
};

const getSettingsById = (settingId) => {
  switch (settingId) {
    case settingIds.THIS_COLUMN: {
      return {
        popover: {
          content: i18next.t('Align the content inside this column vertically'),
          imgSrc: previewGifs.COLUMN_VERTICAL_CONTENT_ALIGNMENT_GIF,
        },
      };
    }
    case settingIds.ALL_COLUMNS: {
      return {
        querySelector: 'ws-column',
        popover: {
          content: i18next.t('Align the content inside columns vertically'),
          imgSrc: previewGifs.COLUMNS_VERTICAL_CONTENT_ALIGNMENT_GIF,
        },
      };
    }
    default:
      return {};
  }
};

const getVerticalContentAlignment = (settingId, settings = {}) => ({
  ...settings,
  ...getSettingsById(settingId),
  id: controlIds.VERTICAL_CONTENT_ALIGNMENT,
  title: i18next.t('Vertical'),
  targets: [targetAttributes.VERTICAL_ALIGNMENT],
  computeFallbackValue: computeContentAlignmentFallback,
  choices: [
    {
      ...ALIGNMENTS.top,
      label: i18next.t('Top'),
    },
    {
      ...ALIGNMENTS.center,
      label: i18next.t('Center'),
    },
    {
      ...ALIGNMENTS.bottom,
      label: i18next.t('Bottom'),
    },
  ],
});

export default getVerticalContentAlignment;
